import { getToken } from '@/libs/util.token'

export default ({ request }) => ({
  sysUserListApi(data = {}) {
    return request({
      url: '/sys/user/list',
      method: 'post',
      data,
    })
  },
  sysUserDelApi(data = {}) {
    return request({
      url: '/sys/user/del',
      method: 'post',
      data,
    })
  },
  sysUserDeactivateApi(data = {}) {
    return request({
      url: '/sys/user/deactivate',
      method: 'post',
      data,
    })
  },
  sysUserEnableApi(data = {}) {
    return request({
      url: '/sys/user/enable',
      method: 'post',
      data,
    })
  },
  sysUserDetailApi(data = {}) {
    return request({
      url: '/sys/user/detail',
      method: 'post',
      data,
    })
  },
  sysUserSaveApi(data = {}) {
    return request({
      url: '/sys/user/save',
      method: 'post',
      data,
    })
  },
  sysUserRoleListApi(data = {}) {
    return request({
      url: '/sys/user/loadUserRole',
      method: 'post',
      data,
    })
  },
  sysUserResetPasswordApi(data = {}) {
    return request({
      url: '/sys/user/resetPassword',
      method: 'post',
      data,
    })
  },
  sysUserWithExcelBatchImportApi({
    file,
    isSave = false,
  } = {}) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('isSave', isSave)

    return request({
      url: '/sys/user/withExcelBatchImport',
      method: 'post',
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
      data: formData,
      timeout: 60 * 5 * 1000,
    })
  },
})
